module.exports = __webpack_public_path__ + "img/dog-leashed.1d6a3f5a.svg";